export const LEAD_STATUS_META = {
  new: { label: "New", cls: "border-blue-200 text-blue-600 dark:border-blue-500/30 dark:text-blue-400" },
  active: { label: "Active", cls: "border-amber-200 text-amber-600 dark:border-amber-500/30 dark:text-amber-400" },
  waiting_on_customer: { label: "Waiting on Customer", cls: "border-violet-200 text-violet-600 dark:border-violet-500/30 dark:text-violet-400" },
  won: { label: "Won", cls: "border-emerald-200 text-emerald-600 dark:border-emerald-500/30 dark:text-emerald-400" },
  lost: { label: "Lost", cls: "border-red-200 text-red-600 dark:border-red-500/30 dark:text-red-400" },
};

export const LOST_REASON_LABELS = {
  customer_declined: "Customer declined", price: "Price", no_response: "No response",
  outside_service_area: "Outside service area", competitor: "Competitor", timing: "Timing",
  service_unavailable: "Service unavailable", other: "Other",
};

export const WORKFLOW_STEP_LABELS = {
  service_area: "Service Area", team_assignment: "Team Assignment", availability: "Availability",
};
export const WORKFLOW_STEPS_ORDER = ["service_area", "team_assignment", "availability"];

export const WORKFLOW_STATE_META = {
  not_started: { label: "Not Started", cls: "text-slate-400" },
  in_progress: { label: "In Progress", cls: "text-amber-600 dark:text-amber-400" },
  waiting_on_customer: { label: "Waiting on Customer", cls: "text-violet-600 dark:text-violet-400" },
  complete: { label: "Complete", cls: "text-emerald-600 dark:text-emerald-400" },
  not_required: { label: "Not Required", cls: "text-slate-400" },
  blocked: { label: "Blocked", cls: "text-red-500 dark:text-red-400" },
};
export const WORKFLOW_STATES_EDITABLE = ["not_started", "in_progress", "waiting_on_customer", "complete", "not_required", "blocked"];

export const SERVICE_AREA_STATUS_META = {
  matched: { label: "✓ Address Verified", cls: "text-emerald-600 dark:text-emerald-400" },
  ambiguous: { label: "✓ Address Verified — multiple areas match, needs manual review", cls: "text-amber-600 dark:text-amber-400" },
  outside: { label: "✓ Address Verified — Outside Current Service Areas", cls: "text-red-500 dark:text-red-400" },
};

export const BUSINESS_ITEM_TYPE_LABELS = { service: "Service", product: "Product", bundle: "Bundle" };

export const formatCents = (cents) => (cents == null ? null : `$${(cents / 100).toFixed(2)}`);

export const channelForContactMethod = (method) => {
  if (method === "Phone" || method === "Text") return "sms";
  if (method === "Email") return "email";
  return null;
};

export const ASSESSMENT_STATUS_META = {
  not_started: { label: "Not Started", cls: "border-slate-200 text-slate-500 dark:border-white/15 dark:text-slate-400" },
  in_progress: { label: "In Progress", cls: "border-amber-200 text-amber-600 dark:border-amber-500/30 dark:text-amber-400" },
  scheduled: { label: "Scheduled", cls: "border-blue-200 text-blue-600 dark:border-blue-500/30 dark:text-blue-400" },
  completed: { label: "Completed", cls: "border-emerald-200 text-emerald-600 dark:border-emerald-500/30 dark:text-emerald-400" },
  not_required: { label: "Not Required", cls: "border-slate-200 text-slate-400 dark:border-white/10 dark:text-slate-500" },
};

export const COMMERCIAL_STATUS_META = {
  Draft: { label: "Draft", cls: "border-slate-200 text-slate-500 dark:border-white/15 dark:text-slate-400" },
  Ready: { label: "Ready", cls: "border-violet-200 text-violet-600 dark:border-violet-500/30 dark:text-violet-400" },
  Sent: { label: "Sent", cls: "border-blue-200 text-blue-600 dark:border-blue-500/30 dark:text-blue-400" },
  Viewed: { label: "Viewed", cls: "border-cyan-200 text-cyan-600 dark:border-cyan-500/30 dark:text-cyan-400" },
  Accepted: { label: "Accepted", cls: "border-emerald-200 text-emerald-600 dark:border-emerald-500/30 dark:text-emerald-400" },
  Declined: { label: "Declined", cls: "border-red-200 text-red-600 dark:border-red-500/30 dark:text-red-400" },
  Expired: { label: "Expired", cls: "border-orange-200 text-orange-600 dark:border-orange-500/30 dark:text-orange-400" },
  Superseded: { label: "Superseded", cls: "border-slate-200 text-slate-400 dark:border-white/10 dark:text-slate-500" },
};

export const LEAD_FILE_CATEGORY_LABELS = { photo: "Photo", document: "Document", measurement: "Measurement", plan: "Plan", specification: "Specification", other: "Other" };

export const dollarsToCents = (v) => Math.round((parseFloat(v || 0) || 0) * 100);
export const centsToDollars = (c) => (c == null ? "" : (c / 100).toFixed(2));
